var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsSettings = function SvgFormsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03 2.625a1.305 1.305 0 001.94 0l.63-.692a1.306 1.306 0 012.273.942l-.047.934a1.307 1.307 0 001.367 1.369l.934-.047a1.306 1.306 0 01.94 2.273l-.695.627a1.307 1.307 0 000 1.939l.695.627a1.306 1.306 0 01-.942 2.273l-.934-.047a1.305 1.305 0 00-1.37 1.37l.047.934a1.306 1.306 0 01-2.268.94l-.627-.694a1.305 1.305 0 00-1.939 0l-.63.694a1.306 1.306 0 01-2.27-.939l.047-.933a1.306 1.306 0 00-1.37-1.371l-.934.047a1.305 1.305 0 01-.944-2.271l.694-.627a1.307 1.307 0 000-1.939l-.694-.63a1.305 1.305 0 01.94-2.27l.933.047a1.305 1.305 0 001.372-1.374l-.045-.934a1.306 1.306 0 012.271-.94l.627.692z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9a3 3 0 106 0 3 3 0 00-6 0v0z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsSettings;